import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalAlertaOK = _resolveComponent("ModalAlertaOK")!
  const _component_LoaderFullScreen = _resolveComponent("LoaderFullScreen")!
  const _component_DialogoSistema = _resolveComponent("DialogoSistema")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalAlertaOK, {
      ref: "modalSessaoExpirada",
      titulo: "Atenção",
      mensagem: `Sessão expirada por inatividade. Você será redirecionado para o login!`,
      onOnSim: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmarEncerramentoSessao()))
    }, null, 512),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderFullScreen, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_DialogoSistema),
    _cache[2] || (_cache[2] = _createElementVNode("p", {
      id: "anuncio-navegacao",
      class: "regiao-anuncio",
      role: "status",
      "aria-live": "polite",
      "aria-atomic": "true"
    }, null, -1)),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layout), null, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_router_view, {
          layout: _ctx.layout,
          "onUpdate:layout": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.layout) = $event)),
          layoutModifiers: { sync: true },
          key: _ctx.keyRV
        }, null, 8, ["layout"]))
      ]),
      _: 1
    }))
  ], 64))
}